var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-page member-layout",style:(_vm.layoutHeight)},[_c('aside',{staticClass:"member-sidebar pt-6"},[_c('Menu',{attrs:{"selectedKeys":_vm.selectedKeys}})],1),_c('main',{staticClass:"member-main"},[_c('route-view',{key:_vm.$store.state.user.sessionVersion})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }